import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from './UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import StripeAccount from './StripeAccount';
import FAQSection from './FAQSection';
import stripeLogo from '../assets/images/stripe.webp';
import { Link } from 'react-router-dom';
import api from "../api/apiClient";

const Dashboard = () => {
  const { currentUser } = useContext(UserContext);
  const [activeSection, setActiveSection] = useState('konto');
  const [isHowToModalOpen, setHowToModalOpen] = useState(false);
  const [fullName, setFullName] = useState(currentUser.full_name || '');
  const [email, setEmail] = useState(currentUser.email || '');
  const [username, setUsername] = useState(currentUser.username || '');
  const [address, setAddress] = useState(currentUser.address || '');
  const [postalCode, setPostalCode] = useState(currentUser.postal_code || '');
  const [city, setCity] = useState(currentUser.city || '');
  const [country, setCountry] = useState(currentUser.country || 'SE');
  const [saveSuccess, setSaveSuccess] = useState(false);
  
  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post('/api/update-profile', {
        user_id: currentUser.id,
        full_name: fullName,
        address,
        postal_code: postalCode,
        city,
        country
      });
  
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (error) {
      console.error("Uppdatering misslyckades:", error);
      alert("Kunde inte spara ändringar.");
    }
  };
  
  if (!currentUser) {
    return (
      <main className="w-full min-h-screen flex items-center justify-center bg-neutral-100">
        <p className="text-lg text-neutral-700">
          Du måste vara inloggad för att se din dashboard.
        </p>
      </main>
    );
  }

  return (
    <main className="w-full bg-neutral-100 p-6 min-h-screen pt-24">
      {activeSection === 'konto' && (
        <article className="w-full max-w-3xl mx-auto bg-warmWhite shadow rounded-lg p-6">
          <h1 className="text-4xl font-bold mb-4 text-center text-turquoise">
            <FontAwesomeIcon icon={faUser} className="mr-2 text-softYellow" />
            Ditt Konto
          </h1>
         
          <form
  className="space-y-4 text-gray-800 max-w-xl mx-auto"
  onSubmit={handleProfileUpdate}
>
  

  <div className="flex items-center">
    <label className="font-semibold w-1/3 text-left pr-4">Namn:</label>
    <input
      className="w-2/3 border p-2 rounded text-right"
      type="text"
      value={fullName}
      onChange={(e) => setFullName(e.target.value)}
    />
  </div>

  <div className="flex items-center">
    <label className="font-semibold w-1/3 text-left pr-4">Email:</label>
    <input
      className="w-2/3 border p-2 rounded text-right" 
      type="email"
      value={email}
      disabled
    />
  </div>

  <div className="flex items-center">
    <label className="font-semibold w-1/3 text-left pr-4">Användarnamn:</label>
    <input
      className="w-2/3 border p-2 rounded text-right"
      type="text"
      value={username}
      disabled
    />
  </div>

  <div className="flex items-center">
    <label className="font-semibold w-1/3 text-left pr-4">Adress:</label>
    <input
      className="w-2/3 border p-2 rounded text-right"
      type="text"
      value={address}
      onChange={(e) => setAddress(e.target.value)}
    />
  </div>

  <div className="flex items-center">
    <label className="font-semibold w-1/3 text-left pr-4">Postnummer:</label>
    <input
      className="w-2/3 border p-2 rounded text-right"
      type="text"
      value={postalCode}
      onChange={(e) => setPostalCode(e.target.value)}
    />
  </div>

  <div className="flex items-center">
    <label className="font-semibold w-1/3 text-left pr-4">Stad:</label>
    <input
      className="w-2/3 border p-2 rounded text-right"
      type="text"
      value={city}
      onChange={(e) => setCity(e.target.value)}
    />
  </div>

  <div className="flex items-center">
    <label className="font-semibold w-1/3 text-left pr-4">Land:</label>
    <select
      className="w-2/3 border p-2 rounded text-right"
      value={country}
      onChange={(e) => setCountry(e.target.value)}
    >
      <option value="SE">Sverige</option>
      <option value="NO">Norge</option>
      <option value="FI">Finland</option>
      <option value="DK">Danmark</option>
      <option value="US">USA</option>
    </select>
  </div>

  <div className="flex justify-end mt-6">
    <button
      type="submit"
      className="bg-turquoise text-white px-6 py-2 rounded hover:scale-105 transition-transform"
    >
      Spara Ändringar
    </button>
  </div>
  {saveSuccess && (
  <div className="mb-4 bg-white text-gray-600 px-6 py-4 rounded-lg text-center shadow-lg">
  ✅  Dina uppgifter har sparats!
</div>


)}
</form>


          <div className="mt-6">
            <p className="text-gray-600 text-sm">
              Här kan du se din kontoinformation och lägga till dina Stripe-detaljer för att få utbetalningar. Om du behöver
              hjälp kan du öppna vår guide genom att klicka på knappen nedan.
            </p>
          </div>

          <div className="mt-6 flex justify-center space-x-4">
            <button
              onClick={() => setHowToModalOpen(true)}
              className="bg-turquoise text-white font-semibold px-6 py-3 rounded shadow-lg hover:bg-teal-600 transition-transform transform hover:scale-105"
              >
              Stripe Guide
            </button>
          </div>
        </article>
      )}
      <section className="w-full max-w-3xl mx-auto bg-gradient-to-br from-yellow-100 via-orange-100 to-pink-100 rounded-lg shadow-md p-6 my-12 text-center">
  <h2 className="text-3xl font-bold text-turquoise mb-4">
    Tjäna pengar som Affiliate! 💸
  </h2>
  <p className="text-gray-700 mb-6 text-lg">
    Tipsa andra om Barnboken och få betalt varje gång någon köper stjärnor med din rabattkod.
    Perfekt för kreatörer, influencers och storytellers!
  </p>
  <Link to="/affiliate">
    <button
      className="bg-turquoise text-white font-semibold px-6 py-3 rounded shadow-lg hover:bg-teal-600 transition-transform transform hover:scale-105"
    >
      Bli Affiliate Nu
    </button>
  </Link>
</section>

<div className="mt-12">
    <FAQSection />
  </div>

      {isHowToModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-warmWhite w-[500px] rounded shadow-lg p-6 relative">
            <button
              className="absolute top-2 right-2 bg-lavenderPurple text-white px-2 py-1 rounded hover:shadow-md transition-shadow duration-200"
              onClick={() => setHowToModalOpen(false)}
            >
              X
            </button>
            <h2 className="text-2xl font-bold mb-4 text-center text-turquoise">
              <FontAwesomeIcon icon={faInfoCircle} className="mr-2 text-gold" />
              Hur lägger jag till Stripe?
            </h2>
            <ol className="list-decimal list-inside space-y-4 text-gray-700">
              <li>
                Logga in på ditt <a href="https://dashboard.stripe.com" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">Stripe-konto</a>.
              </li>
              <li>
                Gå till <strong>Inställningar</strong> och välj <strong>API</strong>-inställningar.
              </li>
              <li>
                Kopiera ditt <strong>Account ID</strong> som börjar med <code>acct_</code>.
              </li>
              <li>Klistra in ditt Account ID i fältet här på din kontosida.</li>
              <li>Klicka på <strong>Spara</strong> för att lagra dina detaljer.</li>
            </ol>
            <div className="mt-6 flex justify-center">
              <img src={stripeLogo} alt="Stripe" className="h-6" title="Betalningar hanteras av Stripe" />
            </div>
            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setHowToModalOpen(false)}
                className="bg-turquoise text-white px-4 py-2 rounded hover:bg-turquoise transition-transform transform hover:scale-105"
              >
                Stäng
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default Dashboard;
